import {GridOverlay} from "@mui/x-data-grid";
import {LinearProgress} from "@mui/material";
import * as React from "react";

export default function CustomTableLoader() {
    return (
        <GridOverlay>
            <div style={{ position: 'absolute', top: 0, width: '100%' }}>
                <LinearProgress />
            </div>
            {/* <div style={{ position: 'absolute', bottom: 0, width: '100%' }}> commented as per the task #901588088
                <LinearProgress />
            </div> */}
        </GridOverlay>
    );
}

